'use client'
import { AppBar, Box } from '@mui/material'
import { motion, useMotionValueEvent, useScroll, Variants } from 'framer-motion'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useRef, useState, useMemo, startTransition } from 'react'
import { MainBar } from './components/main-bar'
import MarqueeText from './components/MarqueText'
import { TopBarV2 } from './components/top-bar'
gsap.registerPlugin(ScrollTrigger)
type Props = {
  categories: ICategoryMenu | null | undefined
}

const HeaderV2 = ({ categories }: Props) => {
  // const categories = await fetchAsideCategories()
  const [hidden, setHidden] = useState(false)
  const { scrollY } = useScroll()
  const lastYRef = useRef(0)
  // throttle bằng rAF để giảm tần suất setState khi scroll
  const rafRef = useRef<number | null>(null)

  const variants = useMemo<Variants>(
    () => ({
      visible: { y: '0%' },
      hidden: { y: '-100%' },
      peeking: { y: '0%', cursor: 'pointer' },
    }),
    []
  )

  useMotionValueEvent(scrollY, 'change', (y) => {
    if (rafRef.current) return
    rafRef.current = requestAnimationFrame(() => {
      const difference = y - lastYRef.current
      if (Math.abs(difference) > 100) {
        const nextHidden = difference > 0
        if (nextHidden !== hidden) {
          // giảm ưu tiên render bằng startTransition
          startTransition(() => setHidden(nextHidden))
        }
        lastYRef.current = y
      }
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current)
        rafRef.current = null
      }
    })
  })

  return (
    <motion.div
      animate={hidden ? 'hidden' : 'visible'}
      initial="visible"
      whileHover={hidden ? 'peeking' : 'visible'}
      onFocusCapture={hidden ? () => setHidden(false) : undefined}
      variants={variants}
      transition={{ duration: 0.2 }}
      className="fixed top-0 z-10 flex w-full justify-center pt-3"
    >
      <AppBar
        sx={{
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
          height: 'var(--size-hd)',
          zIndex: 100,
          background: '#fff',
          boxShadow: 'unset',
          borderBottom: '1px solid #e0e0e0',
          // gợi ý tối ưu GPU cho transform
          willChange: 'transform',
        }}
      >
        <TopBarV2 />
        {/* Main Header */}
        <MainBar categories={categories} />
        {/* Mobile Bottom Navigation
      <NavbarBottom /> */}
      </AppBar>
    </motion.div>
  )
}
export default HeaderV2
